import { render, staticRenderFns } from "./ScoresTable.vue?vue&type=template&id=f47cd04a&scoped=true&"
import script from "./ScoresTable.vue?vue&type=script&lang=ts&"
export * from "./ScoresTable.vue?vue&type=script&lang=ts&"
import style0 from "./ScoresTable.vue?vue&type=style&index=0&id=f47cd04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47cd04a",
  null
  
)

export default component.exports